import { createRouter, createWebHistory } from "vue-router";
import { useUserStateStore } from "../stores/userState";
import { useAppStateStore } from "../stores/appState";
import adminRoutes from "./adminRoutes";
import resultRoutes from "./resultRoutes";
import studyRoutes from "./studyRoutes";
import subjectRoutes from "./subjectRoutes";
import userRoutes from "./userRoutes";
import builderRoutes from "./builderRoutes";
import builderPreviewRoutes from "./builderPreviewRoutes";
import { h } from "vue";
/*
    routes 배열의 객체 속성
    path : 이동할 주소
    component : 해당 주소에서 보여줄 컴포넌트 페이지
    meta : 그 외 필요한 정보, 안에 속성은 임의로 지정
        -- requiresAuth : true시 로그인이 필요한 페이지를 의미함 로그인이 안되어 있다면 로그인 페이지로
        -- hideSideMenu : 좌측 사이드메뉴의 Visible, UnVisivle 처리에 사용
*/
const routes = [
  {
    path: "/login", // MainView 컴포넌트를 보여줄 URL
    alias: "/main", // path와 다른 url을 사용하면서도 동일한 페이지를 보여주고 싶을 때 사용 배열로도 사용가능
    component: () => import("../views/LoginView.vue"),
    children: [
      // Children 중첩 라우트 (부모 요소 뒤에 오는 URL을 매핑)
      // 부몬 컴포넌트 안에서 router-view를 통해 랜더링
      // EX) /studyRegist,  /admin/userManagement
      {
        path: "",
        name: "Login2",
        component: () => import("../views/LoginView.vue"),
        meta: {
          title: "KHRDC-Login",
          requiresAuth: false,
          hideSideMenu: true,
          hideThemeSwitcher: true,
        },
      },
    ],
  },
  {
    // 커머셜(다학회) 로그인 페이지
    path: "/clogin",
    name: "CommercialLogin",
    component: () => import("../views/PortalLoginView.vue"),
    meta: {
      title: "U2EDC-Login",
      requiresAuth: false,
      hideSideMenu: true,
      hideThemeSwitcher: true,
    },
  },
  {
    // 커머셜(다학회) 회원가입 페이지
    path: "/cregister",
    name: "CommercialRegister",
    component: () => import("../views/PortalRegisterView.vue"),
    meta: {
      title: "U2EDC-SignUp",
      requiresAuth: false,
      hideSideMenu: true,
      hideThemeSwitcher: true,
    },
  },
  {
    path: "/", // MainView 컴포넌트를 보여줄 URL
    alias: "/main2", // path와 다른 url을 사용하면서도 동일한 페이지를 보여주고 싶을 때 사용 배열로도 사용가능
    component: () => import("../views/MainView.vue"),
    children: [
      // Children 중첩 라우트 (부모 요소 뒤에 오는 URL을 매핑)
      // 부몬 컴포넌트 안에서 router-view를 통해 랜더링
      // EX) /studyRegist,  /admin/userManagement
      {
        path: "",
        name: "Dashboard",
        // component: () => import("../form/main/Dashboard.vue") Lazy-loaded Component (지연 로딩 컴포넌트)
        // Vue는 기본적으로 처음에 사용자가 모든 컴포넌트를 로드(다운로드) 하지만 지연 로딩 컴포넌트 기법을 사용하면 해당 url로 접근할때 컴포넌트를 다운로드
        component: () => import("../form/main/Dashboard.vue"),
        meta: { title: "KHRDC" },
      },
      {
        path: "institution",
        name: "InstitutionViewer",
        component: () => import("../form/main/Institution.vue"),
        meta: { title: "KHRDC", hideLogo: true },
      },
      {
        path: "studyRegist",
        name: "Study",
        component: () => import("../form/main/Study.vue"),
        meta: { title: "KHRDC", requiresAuth: true },
      },
      {
        path: "studyEnroll",
        name: "StudyEnroll",
        component: () => import("../form/main/EnrollStudy.vue"),
        meta: { title: "KHRDC", requiresAuth: true },
      },
      {
        path: "study",
        // name: 'StudyManagement',
        component: () => import("../form/resultEntry/Study.vue"),
        meta: { title: "Study-Mangement", requiresAuth: true },
      },
    ],
  },
  {
    path: "/admin",
    component: () => import("../views/AdminView.vue"),
    children: [...adminRoutes],
  },
  {
    path: "/user",
    component: () => import("../views/UserView.vue"),
    children: [...userRoutes],
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/RegisterView.vue"),
    meta: { title: "KHRDC-SignUp", requiresAuth: false, hideSideMenu: true },
  },
  {
    path: "/result",
    name: "Result",
    component: () => import("../views/ResultEntryView.vue"),
    meta: {
      title: (to) => {
        const token = to.query.token;
        if (!token) return "KHRDC-ResultEntry";
        const raw =
          localStorage.getItem(`subject-token-${token}`) ||
          sessionStorage.getItem(`subject-token-${token}`);
        if (!raw) return "KHRDC-ResultEntry";

        try {
          const data = JSON.parse(raw);
          const study = data.StudyName || data.StudyShortName || "Study";
          const subject = data.SubjectNo || "";
          return subject ? `${study} · ${subject}` : `${study}`;
        } catch {
          return "KHRDC-ResultEntry";
        }
      },
      requiresAuth: true,
      hideSideMenu: false,
    },
    children: [...resultRoutes],
  },
  {
    path: "/subject",
    name: "Subject",
    component: () => import("../views/SubjectView.vue"),
    meta: { title: "KHRDC-SignUp", requiresAuth: true, hideSideMenu: false },
    children: [...subjectRoutes],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: () => {
      return window.location.hostname.includes('khrdc') ? '/login' : '/clogin';
    },
  },
  {
    // ⚠ 빌더 프리뷰 전용 라우트 - /builder/preview 하위 (기존 /builder와 별개)
    // 반드시 /builder route보다 앞에 위치해야 Vue Router가 먼저 매칭함
    path: "/builder/preview",
    component: () => import("../views/BuilderPreviewView.vue"),
    meta: { requiresAuth: false },
    children: [...builderPreviewRoutes],
  },
  {
    path: "/builder",
    component: () => import("../views/BuilderView.vue"),
    children: [...builderRoutes],
  },
];

// Vue Router를 사용할 수 있는 라우터 인스터스를 생성
const router = createRouter({
  // 히스토리 모드 설정 createWebHistory을 일반적인 SPA 환경에서 가장 많이 사용
  // createWebHashHistory() : /#/dashboded 형식이며 오래된 브라우저에 대응, createMemoryHistory() SSR에서 사용됨
  history: createWebHistory(),
  routes,
});

// 호스트명에 따라 로그인 경로 반환
const getLoginPath = () => {
  return window.location.hostname.includes('khrdc') ? '/login' : '/clogin';
};

/*
    네비게이션 가드
    beforeEach : 페이지가 이동하기 전 실행되는 로직
    페이지에 접근 권한 확인(로그인 여부) 혹은 페이지 이동 전 실행되어야할 로직을 수행
*/
router.beforeEach((to, from, next) => {
  const userStore = useUserStateStore();
  const appStore = useAppStateStore();
  appStore.currentPath = to.fullPath;
  // if (to.meta.title) {
  //   document.title = to.meta.title;  // 🔹 타이틀 업데이트
  // }

  const brand = window.location.hostname.toLowerCase().endsWith("khrdc.org")
    ? "KHRDC"
    : "U2EDC";
  let title = brand;
  const metaTitle = to.meta?.title;
  if (typeof metaTitle === "function") {
    title = `${metaTitle(to)} `;
  } else if (typeof metaTitle === "string") {
    title = `${metaTitle} `;
  }
  document.title = title.replace(/^(KHRDC|U2EDC)/, brand);

  if (to.meta.requiresAuth && !userStore.isAuthenticated) {
    // 기존에 이동할 페이지의 경로를 appStore에 저장
    appStore.setRedirectPath(to.fullPath);
    next(getLoginPath());
  } else if (to.path == "/clogin" || to.path == "/cregister") {
    if (userStore.isAuthenticated) {
      next("/");
      return;
    }
    next();
  } else if (to.path == "/login" || to.path == "/register") {
    // 로그인한 사용자가 오면 이동하고 끝낸다 (return 이 없으면 next 가 두 번 불린다)
    if (userStore.isAuthenticated) {
      next(
        "/subject?AssociationID=1&StudyID=33&StudyName=Ko-CARTR&StudyNo=KSH2501",
      );
      return;
    }
    next();
  } else {
    if (
      to.meta.isAdmin &&
      userStore.isAuthenticated &&
      userStore.user.UserType !== "S"
    ) {
      next("/login");
      return;
    }
    appStore.setRedirectPath(to.fullPath);
    next();
  }
});

export default router;
